import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-detail',
	path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
	exact: true,
};
